<template>
	<window-view title="Bruger" v-on="$listeners" :width="400" :actions="_actions">
		<panel-view>
			<panel-sep-view>
				<grid-view>
					<input-view v-model="m.username" label="Brugernavn" />
				</grid-view>
				<grid-view v-if="!m.id">
					<input-view v-model="m.password" label="Adgangskode" type="password" />
					<div>
						<small>
							<ul>
								<li :class="{ accepted: _minLength }">Adgangskoden skal være på mindst 12 tegn</li>
								<li :class="{ accepted: _containsUppercase }">Indeholde mindst ét stort bogstav</li>
								<li :class="{ accepted: _containsNumber }">Indeholde mindst ét tal</li>
								<li :class="{ accepted: _containsSpecial }">Indeholde mindst ét specialtegn</li>
							</ul>
						</small>
					</div>
				</grid-view>
				<grid-view>
					<input-view v-model="m.name" label="Navn" />
				</grid-view>
				<grid-view>
					<input-view v-model="m.email" label="E-mail" />
				</grid-view>
				<grid-view>
					<select-view v-model="m.role" :options="_roles" label="Brugertype" />
				</grid-view>				
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import user from '../../../model/user';

	const AQT_ROLES = {
		AQT_ADMIN: {
			label: 'Aquatime',
			class: 'AQT_ADMIN',
		},
		AQT_CUSTOMER: {
			label: 'Kunde',
			class: 'AQT_CUSTOMER',
		},
		AQT_PARTNER: {
			label: 'Partner',
			class: 'AQT_PARTNER',
		},
	};

	export default {
		props: ['model', 'submit'],
		data() {
			return {
				id: '',
				m: user.model(),
			};
		},
		computed: {
			_roles() {
				return Object.keys(AQT_ROLES).map(key => {
					return {
						label: AQT_ROLES[key].label,
						value: AQT_ROLES[key].class,
					};
				});
			},
			_actions() {
				const self = this;

				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							if (!this._allRulesValid) {
								alert('Din adgangskode overholder ikke kravene');
								return false;
							}

							return self.submit(this.m);
						}
					}
				];
			},
			// Check if password is at least 8 characters long
			_minLength() {
				return this.m.password.length >= 12;
			},
			
			// Check if password contains at least one uppercase letter
			_containsUppercase() {
				return /[A-Z]/.test(this.m.password);
			},
			
			// Check if password contains at least one number
			_containsNumber() {
				return /\d/.test(this.m.password);
			},
			
			// Check if password contains at least one special character
			_containsSpecial() {
				return /[!@#$%^&*(),.?":{}|<>]/.test(this.m.password);
			},
			
			// Check if all rules are satisfied
			_allRulesValid() {
				return this.minLength && this.containsUppercase && this.containsNumber && this.containsSpecial;
			},
		},
		async created() {
			console.log('m', this.model);
			this.m = {...this.m, ...this.model};
		}
	}
</script>

<style lang="scss" scoped>
	ul {
		margin-left: 20px;

		li {
			font-size: 12px;

			&.accepted {
				color: green;
			}
		}
	}
</style>